const getCurrentYear = () => {
    return new Date().getFullYear();
};

export default getCurrentYear;
